<template>
  <Teleport to="body">
    <Transition>
      <div
        v-if="opened"
        class="absolute top-0 bottom-0 right-0 left-0 z-50"
        @click="$emit('close')"
      >
        <div class="h-screen flex items-center justify-center py-16 px-11">
          <div
            class="shadow-floating overflow-y-auto max-h-full w-full md:max-w-[500px] rounded-xl bg-white"
            @click="handleContentClick"
          >
            <slot></slot>
          </div>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script setup lang="ts">
export interface UModalProps {
  opened: boolean
}

defineProps<UModalProps>()

export interface UModalEmits {
  (e: 'close'): void
}

defineEmits<UModalEmits>()

const handleContentClick = (e: MouseEvent) => {
  e.stopPropagation()
}
</script>

<style scoped>
.v-enter-active,
.v-leave-active {
  @apply transition-opacity duration-300 ease-in-out;
}

.v-enter-from,
.v-leave-to {
  @apply opacity-0;
}
</style>
